"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var capitalize_1 = __importDefault(require("./capitalize"));
function toCamelCase(string) {
    var separator = '-|_|(?=[A-Z])', regex = new RegExp(separator, 'g');
    return string.split(regex).map(function (word, index) { return index > 0 ? capitalize_1.default(word) : word.toLowerCase(); }).join('');
}
exports.default = toCamelCase;
//# sourceMappingURL=toCamelCase.js.map